export const setLoanVisibility = (productList, filters) => {

    let activeFilters = [] ;
    let counter=0;
    for (const prop in filters) {
        if (filters[prop]) {
            activeFilters.push(prop);
            if (prop!='online'){
                counter++;
            }
        }
    }

    let index1 = activeFilters.indexOf('fixedInterest');
    let index2 = activeFilters.indexOf('variableInterest');

    if( index1 > -1 && index2 >-1) {
        activeFilters.splice(index1,1);
        index2 = activeFilters.indexOf('variableInterest');
        activeFilters.splice(index2,1);
    }

    let visibleProducts = 0;
    let filteredProductList = productList.map ( p =>
        {   
            let status = true;
            activeFilters.forEach(f => {
                
                switch (f) {
                    case 'online':
                        if (!p.hasOwnProperty('apply')) {
                            status = false;
                        }
                        break;
                    case 'withIncome':
                        if (p.withIncome) {
                            status = false;
                        }
                        break;
                    case 'lifeInsurance':
                        if (!p.lifeInsurance) {
                            status = false;
                        }
                        break;
                    case 'fixedInterest':
                        if (p.rateType == 'variabila') {
                            status = false;
                        }
                        break;
                    case 'variableInterest':
                        if (p.rateType != 'variabila') {
                            status = false;
                        }
                        break;
                }
            
            });
          
            if (!status) {
                return {...p, visible: false};
            }
            visibleProducts ++;
            return {...p, visible: true};
       
        }
    );
    let response = {
        updatedOffers: filteredProductList,
        visibleProducts,
        counterFilters: counter
    };
    
    return response;
}

export const countFilters = (filters) => {
    let counter=0;
    for (const prop in filters) {
        if (filters[prop]) {
            if (prop!='online'){
                counter++;
            }
        }
    }
    return counter;
}

export const countOffersForFilter  = (productList, filter, online) => {
    switch(filter) {
        case 'online':
            return  productList.reduce( (sum, p) => (
                sum +  (p.hasOwnProperty('apply') && p.apply ? 1 : 0)
            ), 0);
            break;
        case 'withIncome':
            return online ?
            productList.reduce( (sum, p) => (
                sum +  (p.hasOwnProperty('withIncome') && p.withIncome && p.hasOwnProperty('apply') && p.apply ? 1 : 0)
            ), 0) :
            productList.reduce( (sum, p) => (
                sum +  (p.hasOwnProperty('withIncome') && p.withIncome ? 1 : 0)
            ), 0)
            ;
            break;
        case 'lifeInsurance':
            return online ?
             productList.reduce( (sum, p) => (
                sum +  (p.hasOwnProperty('lifeInsurance') && p.lifeInsurance && p.hasOwnProperty('apply') && p.apply ? 1 : 0)
            ), 0) :
             productList.reduce( (sum, p) => (
                sum +  (p.hasOwnProperty('lifeInsurance') && p.lifeInsurance ? 1 : 0)
            ), 0) 
            ;
            break;
        case 'fixedInterest':
            return online ?
             productList.reduce( (sum, p) => (
                sum +  (p.rateType!='variabila' && p.hasOwnProperty('apply') && p.apply  ? 1 : 0)
            ), 0) :
             productList.reduce( (sum, p) => (
                sum +  (p.rateType!='variabila'  ? 1 : 0)
            ), 0);
            break;
        case 'variableInterest':
            return online ?
             productList.reduce( (sum, p) => (
                sum +  (p.rateType=='variabila' && p.hasOwnProperty('apply') && p.apply ? 1 : 0)
            ), 0) :
             productList.reduce( (sum, p) => (
                sum +  (p.rateType=='variabila'  ? 1 : 0)
            ), 0);
            break;
    }

}

export const countOffersByFilters  = (productList, filters) => {
    let counter = {};
    for (const prop in filters){
        counter[prop] = countOffersForFilter(productList, prop, filters.online);
    }
    return counter;
}

export const countOnlineVisibleOffers = (productList, filters) => {
    let newFilters = {...filters, online: true};
    let visibleOffers = countAllVisibleOffers(productList, newFilters);
    return visibleOffers;
}
export const countBankVisibleOffers = (productList, filters) => {
    let newFilters = {...filters, online: false};
    let visibleOffers = countAllVisibleOffers(productList, newFilters);
    return visibleOffers;
}

export const countAllVisibleOffers = (productList, filters) =>{
    let activeFilters = [] ;
   
    for (const prop in filters) {
        if (filters[prop]) {
            activeFilters.push(prop);
        }
    }

    let index1 = activeFilters.indexOf('fixedInterest');
    let index2 = activeFilters.indexOf('variableInterest');

    if( index1 > -1 && index2 >-1) {
        activeFilters.splice(index1,1);
        index2 = activeFilters.indexOf('variableInterest');
        activeFilters.splice(index2,1);
    }

    let visibleProducts = 0;
    let filteredProductList = productList.map ( p =>
        {   
            let status = true;
            activeFilters.forEach(f => {
                
                switch (f) {
                    case 'online':
                        if (!p.hasOwnProperty('apply')) {
                            status = false;
                        }
                        break;
                    case 'withIncome':
                        if (p.withIncome) {
                            status = false;
                        }
                        break;
                    case 'lifeInsurance':
                        if (!p.lifeInsurance) {
                            status = false;
                        }
                        break;
                    case 'fixedInterest':
                        if (p.rateType == 'variabila') {
                            status = false;
                        }
                        break;
                    case 'variableInterest':
                        if (p.rateType != 'variabila') {
                            status = false;
                        }
                        break;
                }
            
            });
          
            if (status) {
                visibleProducts ++;
            }
        }
    );

    return visibleProducts;
}

export const getProductDescription = (product, option) => {

    let options = {
        'personalLoans': {
            'personal loan': 'Nevoi personale',
            'home equity loan': 'Nevoi cu ipoteca'
        },
        'autoLoans' : {
            'new car loan': 'Credit pentru auto nou',
            'used car loan': 'Credit pentru auto second-hand',
            'first car loan': 'Credit Prima Mașină'
        },
        'mortgageLoans' : {
            'mortgage buy': 'Cumpărare locuință',
            'mortgage build': 'Construcție locuință',
            'mortgage repair': 'Modernizare locuință'
        },
        'refinanceLoans' : {
            'mortgage refinance': 'Refinanțare Credit imobiliar',
            'refinance personal loan': 'Refinanțare Credit nevoi personale',
            'refinance home equity loan': 'Refinanțare Credit cu ipotecă',
        },
        'deposits' : {
            'all': 'Depozit la termen',
            'branch': 'Depozit la termen - în sucursală',
            'online': 'Depozit la termen - online',
        },
        'creditCard' : {
            'all': 'Oricare',
            'rewards': 'Puncte bonus',
            'cashback': 'Cashback',
            'freeInterest': 'Rate fără dobândă',
            'premium': 'Premium',
            'balanceTransfer': 'Refinanțare',
        },
        
    }
    return options[product][option];
}

export const checkMortgageDownPayment = (amount, currency, house, houseCurrency, eur) => {

    let minDownPaymentRate = currency=='RON' ? 15 : 25;
    let {housePrice, downPayment, downPaymentRate} = getDownPayment(amount, currency, house, houseCurrency, eur);
    
    if (downPayment <= 0) {
        return ({
            status: false,
            msg: 'Valoarea creditului trebuie să fie mai mare decât valoarea casei'
        });
    }
    
    if (downPaymentRate < minDownPaymentRate) {
        let maxAmount = new Intl.NumberFormat('fr', {maximumFractionDigits: 1}).format(housePrice * (100-minDownPaymentRate)/100);
        return ({
            status: false,
            msg: 'Avansul minim este de '+ minDownPaymentRate + '%. Valoarea creditului nu poate depăși ' + maxAmount + ' ' + currency
        });
    }
    return ({
        status: true,
        msg: ''
    });
}
export const checkRefinanceCollateral = (amount, currency, house, houseCurrency, eur) => {

    let minDownPaymentRate = currency=='RON' ? 15 : 25;
    let minCollateralRate = 100 - minDownPaymentRate;
    let {housePrice, downPayment, downPaymentRate} = getDownPayment(amount, currency, house, houseCurrency, eur);
    
    if (downPayment <= 0) {
        return ({
            status: false,
            msg: 'Valoarea creditului trebuie să fie mai mare decât valoarea garanției imobiliare'
        });
    }
    
    if (downPaymentRate < minDownPaymentRate) {
        let maxAmount = new Intl.NumberFormat('fr', {maximumFractionDigits: 1}).format(housePrice * (100-minDownPaymentRate)/100);
        
        return ({
            status: false,
            msg: 'Banca finanțează maxim '+ minCollateralRate + '% din valoarea garanției imobiliare. Suma maximă ce poate fi refinanțată este de ' + maxAmount + ' ' + currency
        });
    }
    return ({
        status: true,
        msg: ''
    });
}

export const checkFirstHomeHousePrice = ( house, houseCurrency, eur) => {
    let housePriceEur = houseCurrency=='RON' ? house/eur : house;
 
    if (housePriceEur > 140000) {
        let msg = 'Valoarea locuintei nu poate depasi 140.000 euro';
        if (houseCurrency == 'RON') {
            let maxHousePrice = 140000*eur;
            msg += ' (echivalent '+ new Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(maxHousePrice) + ' RON)' ;
        }
        return ({
            status: false,
            msg: msg
        });
    }
    return ({
        status: true,
        msg: ''
    });
}

export const checkFirstHomeDownPayment = (amount, currency, house, houseCurrency, eur) => {

    let housePriceEur = houseCurrency=='RON' ? house/eur : house;
    let {housePrice, downPayment, downPaymentRate} = getDownPayment(amount, currency, house, houseCurrency, eur);
    let minDownPaymentRate = housePriceEur<=70000 ? 5 : 15;
    
    if (downPayment <= 0) {
        return ({
            status: false,
            msg: 'Valoarea creditului trebuie să fie mai mare decât valoarea casei'
        });
    }
    
    if (downPaymentRate < minDownPaymentRate) {
        let maxAmount = new Intl.NumberFormat('fr', {maximumFractionDigits: 1}).format(housePrice * (100-minDownPaymentRate)/100);
        return ({
            status: false,
            msg: 'Avansul minim este de '+ minDownPaymentRate + '%. Valoarea creditului nu poate depăși ' + maxAmount + ' ' + currency
        });
    }
    return ({
        status: true,
        msg: ''
    });
}

export const getDownPayment = (amount, currency, house, houseCurrency, eur) => {
    let housePrice;
    if (currency==houseCurrency) {
        housePrice = house;
    } else {
        housePrice = currency=='RON' ? house*eur : house/eur;
    }
    let downPayment = (housePrice - amount).toFixed(0);
    let downPaymentRate = (downPayment / housePrice * 100).toFixed(1);
    return ({ downPayment, downPaymentRate, housePrice});
} 

export const getDepositInterestType = (val) => {
    switch(val) {
        case 'fixed':
            return 'fixă';
            break;
        case 'variable':
            return 'variabilă';
            break;
    }
}

export const getDepositInterestPayment = (val) => {
    switch(val) {
        case 'term':
            return 'la scadență';
            break;
        case 'month':
            return 'lunar';
            break;
        case 'quarter':
            return 'trimestrial';
            break;
        case 'semester':
            return 'semestrial';
            break;
        case 'advance':
            return 'la constituire';
            break;
    }
}
export const getSavingAccountInterestCalculation = (val) => {
    switch(val) {
        case 'balance':
            return 'la sold';
            break;
        case 'bracket':
            return 'pe trașe';
            break;
    }
}

export const getLoanInterestType = (val) => {
    switch(val) {
        case 'fixa':
            return 'fixă';
            break;
        case 'variabila':
            return 'variabilă';
            break;
        case 'fixa 1 luna':
            return 'fixă 1 lună';
            break;
        case 'fixa 3 luni':
            return 'fixă 3 luni';
            break;
        case 'fixa 6 luni':
            return 'fixă 6 luni';
            break;
        case 'fixa 1 an':
            return 'fixă 1 an';
            break;
        case 'fixa 2 ani':
            return 'fixă 2 ani';
            break;
        case 'fixa 3 ani':
            return 'fixă 3 ani';
            break;
        case 'fixa 5 ani':
            return 'fixă 5 ani';
            break;
        case 'fixa 7 ani':
            return 'fixă 7 ani';
            break;
        case 'fixa 10 ani':
            return 'fixă 10 ani';
            break;
        default:
            return '';
       
    }
}







